/** @auther : IBM **/ /** @date : **/
<template>
  <el-row>
    <el-dialog
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      :before-close="handleClose"
      class="chat_dailog"
    >
      <template slot="title">
        <el-row>
          <!-- <span
            v-if="
              $root.chatRealTimeTableData[index] &&
              $root.chatRealTimeTableData[index].time
            "
            >{{ dialogTitle }} {{ $root.htmlConst.cons_137_call_time }}
            {{ $root.chatRealTimeTableData[index].time }}</span
          > -->
          <span
            v-if="
              $root.chatRealTimeTableData[index] &&
              $root.chatRealTimeTableData[index].time
            "
            >{{ dialogTitle }} {{ "チャット時間" }}
            {{ $root.chatRealTimeTableData[index].time }}</span
          >
          <!-- <span v-else style="min-width: 185px; float: left"
            >{{ dialogTitle }} {{ $root.htmlConst.cons_136_stop }}
          </span> -->
          <span v-else style="min-width: 185px; float: left"
            >{{ dialogTitle }} {{ "チャット終了" }}
          </span>
        </el-row>
        <hr style="color: #f8f8f8; opacity: 0.5" />
        <el-row class="chat-search-input">
          <el-input
            v-if="search != oldSearch"
            v-model="search"
            size="mini"
            :placeholder="$root.htmlConst.cons_140_input"
            clearable
            @keyup.enter.native="searchAllText('search')"
            style="width: 80%"
          ></el-input>
          <el-input
            v-else
            v-model="search"
            size="mini"
            :placeholder="$root.htmlConst.cons_140_input"
            clearable
            @keyup.enter.native="downSelect()"
            style="width: 80%"
          ></el-input>
          <el-button
            v-if="multipleSelection.length"
            type="info"
            @click="upSelect"
            icon="el-icon-caret-top"
            style="margin-left: 1%"
          ></el-button>
          <el-button
            v-else
            type="info"
            @click="upSelect"
            icon="el-icon-caret-top"
            style="margin-left: 1%"
            disabled
          ></el-button>
          <span v-if="search != '' && multipleSelection.length" style="padding: 0 1%"
            >{{ searchIndex }}/{{ multipleSelection.length }}</span
          >
          <span
            v-else-if="search != '' && multipleSelection.length == 0"
            style="padding: 0 1%"
            >0/0</span
          >
          <el-button
            v-if="multipleSelection.length"
            type="info"
            @click="downSelect"
            icon="el-icon-caret-bottom"
          ></el-button>
          <el-button
            v-else
            type="info"
            @click="downSelect"
            icon="el-icon-caret-bottom"
            disabled
          ></el-button>
        </el-row>
      </template>
      <section class="result-content">
        <el-row>
          <el-col :span="12">
            <div style="background-color:#f9e0df">
              <div style="color:#b52c22;font-size:15px;text-align: center">{{ $root.htmlConst.cons_238_chat_text_customer_header }}</div>
              <div style="color:#b52c22;font-size:12px;text-align: center">({{ $root.htmlConst.cons_239_chat_text_customer_small_header }})</div>
            </div>
            <el-table
              :data="allCustomerTextData"
              ref="multipleTableLeft"
              :show-header="false"
              v-loading="loading"
              :element-loading-text="$root.htmlConst.cons_141_data_loading"
              element-loading-spinner="el-icon-loading"
              highlight-current-row
              v-chat-scroll
            >
              <template slot="empty">
                <p>{{ emptyText }}</p>
              </template>
              <el-table-column>
                <template slot-scope="scope">
                  <div
                    class="message_msg"
                    :class="{
                      left: scope.row.flag == 'left',
                      right: scope.row.flag == 'right',
                    }"
                  >
                    <div class="user_headshot">
                      <img
                        :src="scope.row.logo != '' ? scope.row.logo : require('../../assets/operator.png')"
                        v-if="scope.row.role == 'operator'"
                      />
                      <img
                        :src="scope.row.logo != '' ? scope.row.logo : require('../../assets/operator.png')"
                        v-else-if="scope.row.role == 'supervisor'"
                      />
                      <img
                        :src="scope.row.logo != '' ? scope.row.logo : require('../../assets/user_logo.png')"
                        v-else-if="scope.row.role == 'customer'"
                      />
                      <!-- <img src="../../assets/user_logo.png"  v-else-if="scope.row.role == 'customer'" /> -->
                      <!-- <img
                        src="../../assets/watson.gif"
                        v-else-if="scope.row.user == 'Watson'"
                      />
                      <img src="../../assets/user_logo.png" v-else /> -->
                      <!-- <img src="../assets/img/watson_think_stop.gif" v-else> -->
                    </div>
                    <div class="user_msg">
                      <div class="speaker">{{ scope.row.user }}</div>
                      <div class="user_text" v-html="scope.row.text"></div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
          <el-col :span="12">
            <div style="background-color:#daeffd">
              <div style="color:#184263;font-size:15px;text-align: center">{{ $root.htmlConst.cons_240_chat_text_agent_header }}</div>
              <div style="color:#184263;font-size:12px;text-align: center">({{ $root.htmlConst.cons_241_chat_text_agent_small_header }})</div>
            </div>
            <el-table
              :data="allAgentTextData"
              ref="multipleTableRight"
              :show-header="false"
              v-loading="loading"
              :element-loading-text="$root.htmlConst.cons_141_data_loading"
              element-loading-spinner="el-icon-loading"
              highlight-current-row
              v-chat-scroll
            >
              <template slot="empty">
                <p>{{ emptyText }}</p>
              </template>
              <el-table-column>
                <template slot-scope="scope">
                  <div
                    class="message_msg"
                    :class="{
                      left: scope.row.flag == 'left',
                      right: scope.row.flag == 'right',
                    }"
                  >
                    <div class="user_headshot">
                      <img
                        :src="scope.row.logo != '' ? scope.row.logo : require('../../assets/operator.png')"
                        v-if="scope.row.role == 'operatorInner'"
                      />
                      <img
                        :src="scope.row.logo != '' ? scope.row.logo : require('../../assets/operator.png')"
                        v-else-if="scope.row.role == 'supervisorInner'"
                      />
                      <!-- <img
                        src="../../assets/watson.gif"
                        v-else-if="scope.row.user == 'Watson'"
                      />
                      <img src="../../assets/user_logo.png" v-else /> -->
                      <!-- <img src="../assets/img/watson_think_stop.gif" v-else> -->
                    </div>
                    <div class="user_msg">
                      <div class="speaker">{{ scope.row.user }}</div>
                      <div class="user_text" v-html="scope.row.text"></div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </section>
      <div class="footer-box" v-if="svSendFlg">
        <div style="width: 45px; height: 30px; text-align: center" @click="sendMessage('textMonitor')">
          <img
            id="img"
            src="../../assets/customer_send.png"
            style="width: 30px; height: 28px; cursor: pointer"
          />
        </div>
        <!-- <el-input
          v-model="input"
          id="message"
          size="mini"
          clearable
          @keyup.enter.native="sendMessage()"
          style="width:75%"
        ></el-input> -->
        <el-input
          v-model="input"
          id="message"
          type="textarea"
          resize="none"
         :autosize="{ minRows: 1, maxRows: 3 }"
          size="mini"
          style="width:75%"
        ></el-input>
        <div style="width: 45px; height: 30px; text-align: center" @click="sendMessage('svInnerChat')">
          <img
            id="img"
            src="../../assets/agent_send.png"
            style="width: 30px; height: 28px; cursor: pointer"
          />
        </div>
      </div>
      <div class="footer-box" v-else>
        <div style="width: 45px; height: 30px; text-align: center" disabled>
          <img
            id="img"
            src="../../assets/agent_send.png"
            style="width: 30px; height: 28px; cursor: not-allowed;"
          />
        </div>
        <el-input
          v-model="input"
          id="message"
          size="mini"
          disabled="disabled"
          style="width:75%; background-color: #bbbbbb"
        ></el-input>
        <div style="width: 45px; height: 30px; text-align: center" disabled>
          <img
            id="img"
            src="../../assets/customer_send.png"
            style="width: 30px; height: 28px; cursor: not-allowed;"
          />
        </div>
      </div>
    </el-dialog>
    <!-- --------------------------------------------------------------------------------------- -->
    <el-table
      v-if="$root.chatTable"
      :data="$root.chatRealTimeTableData"
      border
      stripe
      v-loading="realTimeloading"
      :element-loading-text="$root.htmlConst.cons_141_data_loading"
      element-loading-spinner="el-icon-loading"
      :height="$root.chatTableHeight"
      style="overflow-y: hidden"
      class="detail-table chat-table"
      :header-cell-style="{padding: '5px 0px'}"
    >
      <template slot="empty">
        <p>{{ emptyText }}</p>
      </template>
      <el-table-column
        key="2"
        prop="groupName"
        :label="$root.htmlConst.cons_113_table_header_group"
        style="float: left"
        :filters="$root.chatRealTimeGroupFilters"
        :filter-method="filterGroup"
        filter-placement="bottom-end"
        width="90"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="19"
        prop="queueNum"
        :label="$root.htmlConst.cons_114_table_header_num"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="3"
        prop="operatorName"
        :label="$root.htmlConst.cons_115_table_header_user"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="20"
        prop="role"
        :label="$root.htmlConst.cons_116_table_header_sv"
        width="60"
        :filters="$root.chatRealTimeSvFilters"
        :filter-method="filterSV"
        filter-placement="bottom-end"
      ></el-table-column>
      <el-table-column
        key="22"
        prop="customName"
        label="お問い合わせ者"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="4"
        :label="$root.htmlConst.cons_118_table_header_access"
        :filters="$root.chatRealTimeStatusFilters"
        :filter-method="filterStatus"
        filter-placement="bottom-end"
        width="110"
        :resizable="false"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.presence == '未読あり'"
            style="background-color: #ffc107; color: #fff"
            >{{ scope.row.presence }}</span
          >
          <span
            v-if="scope.row.presence === '未送信'"
            style="background-color: #bbbb00; color: #fff"
            >{{ scope.row.presence }}</span
          >
          <span
            v-else-if="scope.row.presence === '入力中'"
            style="background-color: #67c23a; color: #fff"
            >{{ scope.row.presence }}</span
          >
          <span
            v-else-if="scope.row.presence === '送信済'"
            style="background-color: #007bff"
            >{{ scope.row.presence }}</span
          >
          <span
            v-else-if="scope.row.presence === 'クローズ待ち'"
            style="background-color: #888888"
            >{{ scope.row.presence }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        key="21"
        prop="svHelp"
        :label="$root.htmlConst.cons_122_table_header_help"
        :resizable="false"
      >
        <el-table-column
          key="99"
          :label="$root.htmlConst.cons_122_table_header_dependent"
          :resizable="false"
        >
          <template slot-scope="scope">
            <!-- <div
              v-if="scope.row.svhelpStatus != ''"
              style="background-color: #e0d7eb; color: #000;"
            > -->
            <div
              :style="{'background-color':scope.row.svhelpStatus=='onSupport'?'#e0d7eb':'', color:scope.row.svhelpStatus=='onSupport'?'#000':''}"
            >
              <span>{{ scope.row.svhelpRequestCount }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          key="98"
          width="140"
          :label="$root.htmlConst.cons_122_table_header_support"
          :resizable="false"
        >
          <template slot-scope="scope">
             <el-button
              type="primary"
              v-if="scope.row.svhelpStatus == 'request' && $root.user.role === 'supervisor'"
              icon="el-icon-s-custom"
              class="sup_btn"
              @click="svHelpClick(scope.row)"
            >サポート必要</el-button>

            <el-tooltip placement="top" v-if="scope.row.svhelpStatus == 'onSupport'">
              <div slot="content">{{ scope.row.svhelperString }}</div>
              <el-button
                class="sup_btn"
                plain
                v-if="scope.row.svhelpStatus == 'onSupport' && 
                  ((scope.row.svhelperString.split(',')[scope.row.svhelpRequestCount - 1].replace(/\s+/g,'') == $root.user.name.replace(/\s+/g,''))
                  || scope.row.svhelpRequestCount == '' || scope.row.svhelpRequestCount == 0)"
                @click="resetSvHelpClick(scope.row)"
              ><img :src="sup_icon1" alt=""> サポート中</el-button>
              <el-button
                class="sup_btn"
                plain
                v-if="scope.row.svhelpStatus == 'onSupport' &&  scope.row.svhelpRequestCount > 0 &&
                  scope.row.svhelperString.split(',')[scope.row.svhelpRequestCount - 1].replace(/\s+/g,'') != $root.user.name.replace(/\s+/g,'')"
                disabled
              ><img :src="sup_icon1" alt=""> サポート中</el-button>
            </el-tooltip>

            <el-button
              type="primary"
              class="sup_btn"
              v-if="scope.row.svhelpStatus == ''"
              icon="el-icon-s-custom"
              style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop"
              disabled
            >サポート不要</el-button>
            <el-button
              type="primary"
              class="sup_btn"
              v-if="scope.row.svhelpStatus == 'request' && $root.user.role === 'operator'"
              icon="el-icon-s-custom"
              style="background-color: #bbbbbb; border-color: #bbbbbb; cursor: no-drop"
              disabled
            >サポート必要</el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        :label="$root.htmlConst.cons_119_table_header_monitor"
        v-if="$root.user.role === 'operator'"
        width="110"
        :resizable="false"
      >
        <el-table-column
          key="6"
          :label="$root.htmlConst.cons_121_table_header_text"
          width="110"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.hasSVNameFlag === true">
              <div slot="content">{{ scope.row.svName }}</div>
              <el-button
                type="primary"
                v-if="scope.row.hasSVNameFlag === true"
                icon="el-icon-document"
                disabled
              ></el-button>
            </el-tooltip>
            <el-button
              type="primary"
              v-else
              icon="el-icon-document"
              style="background-color: #bbb; border-color: #bbb"
              disabled
            ></el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column
        v-else
        key="5"
        :label="$root.htmlConst.cons_119_table_header_monitor"
        width="110"
        :resizable="false"
      >
        <el-table-column
          key="6"
          :label="$root.htmlConst.cons_121_table_header_text"
          width="110"
        >
          <template slot-scope="scope">
            <el-tooltip placement="top" v-if="scope.row.hasSVNameFlag === true">
              <div slot="content">{{ scope.row.svName }}</div>
              <el-button
                type="primary"
                v-if="scope.row.hasSVNameFlag === true"
                icon="el-icon-document"
                @click="viewAllText(scope.$index, scope.row)"
              ></el-button>
            </el-tooltip>
            <el-button
              type="primary"
              v-else
              icon="el-icon-document"
              @click="viewAllText(scope.$index, scope.row)"
              style="background-color: #409eff; border-color: #409eff"
            ></el-button>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column key="27" :label="$root.htmlConst.cons_152_table_header_word_count" :resizable="false">
        <el-table-column key="28" :label="$root.htmlConst.cons_151_table_header_wowword" :resizable="false">
          <el-table-column
            key="23"
            :label="$root.htmlConst.cons_124_table_header_questioner"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                v-if="scope.row.chatQuestionerWowFlg === 'true'"
              >
                <div slot="content">
                  {{ scope.row.chatQuestionerWowWords }}
                </div>
                <div
                  style="background-color: #67c23a; color: #000; float: left; width: 100%"
                  v-if="scope.row.chatQuestionerWowFlg === 'true'"
                >
                  <span>{{ scope.row.chatQuestionerWowWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.chatQuestionerWowWordCount }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            key="39"
            :label="$root.htmlConst.cons_125_table_header_operator"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                v-if="scope.row.chatOperatorWowWordFlg === 'true'"
              >
                <div slot="content">{{ scope.row.chatOperatorWowWords }}</div>
                <div
                  style="background-color: #67c23a; color: #000; float: left; width: 100%"
                  v-if="scope.row.chatOperatorWowWordFlg === 'true'"
                >
                  <span>{{ scope.row.chatOperatorWowWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.chatOperatorWowWordCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column key="26" :label="$root.htmlConst.cons_126_table_header_ngword" :resizable="false">
          <el-table-column
            key="10"
            :label="$root.htmlConst.cons_124_table_header_questioner"
            :resizable="false"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" v-if="scope.row.chatQuestionerNgFlg === 'true'">
                <div slot="content">{{ scope.row.chatQuestionerNgWords }}</div>
                <div
                  style="background-color: #ffc107; color: #000; float: left; width: 100%"
                  v-if="scope.row.chatQuestionerNgFlg === 'true'"
                >
                  <span>{{ scope.row.chatQuestionerNgWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.chatQuestionerNgWordCount }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            key="11"
            :label="$root.htmlConst.cons_125_table_header_operator"
            :resizable="false"
          >
            <template slot-scope="scope">
              <el-tooltip placement="top" v-if="scope.row.chatOperatorNgFlg === 'true'">
                <div slot="content">
                  {{ scope.row.chatOperatorNgWords }}
                </div>
                <div
                  style="background-color: #ffc107; color: #000; float: left; width: 100%"
                  v-if="scope.row.chatOperatorNgFlg === 'true'"
                >
                  <span>{{ scope.row.chatOperatorNgWordCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.chatOperatorNgWordCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column key="25" :label="$root.htmlConst.cons_150_table_header_ngmanner" :resizable="false">
          <el-table-column
            key="24"
            :label="$root.htmlConst.cons_125_table_header_operator"
          >
            <template slot-scope="scope">
              <el-tooltip
                placement="top"
                v-if="scope.row.chatOperatorNgMannerFlg === 'true'"
              >
                <div slot="content">{{ scope.row.chatOperatorNgManners }}</div>
                <div
                  style="background-color: #ffc107; color: #000; float: left; width: 100%"
                  v-if="scope.row.chatOperatorNgMannerFlg === 'true'"
                >
                  <span>{{ scope.row.chatOperatorNgMannerCount }}</span>
                </div>
              </el-tooltip>
              <div style="color: #000" v-else>
                <span>{{ scope.row.chatOperatorNgMannerCount }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column key="13" :label="$root.htmlConst.cons_130_table_header_time" :resizable="false">
        <template slot-scope="scope">
          <div
            style="background-color: #d5934f; color: #000"
            v-if="scope.row.longTimeFlg === 'true'"
          >
            <span>{{ scope.row.time }}</span>
          </div>
          <div v-else>
            <span>{{ scope.row.time }}</span>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-table
      v-else
      :data="$root.chatDailyTableData"
      border
      stripe
      v-loading="dailyloading"
      :element-loading-text="$root.htmlConst.cons_141_data_loading"
      element-loading-spinner="el-icon-loading"
      :height="$root.chatTableHeight"
      style="overflow-y: hidden"
      class="detail-table chat-table"
      :header-cell-style="{padding: '5px 0px'}"
    >
      <template slot="empty">
        <p>{{ emptyText }}</p>
      </template>
      <el-table-column
        key="2"
        prop="groupName"
        :label="$root.htmlConst.cons_113_table_header_group"
        style="float: left"
        :filters="$root.chatDailyGroupFilters"
        :filter-method="filterGroup"
        filter-placement="bottom-end"
        width="90"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="19"
        prop="queueNum"
        :label="$root.htmlConst.cons_114_table_header_num"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="3"
        prop="operatorName"
        :label="$root.htmlConst.cons_115_table_header_user"
        style="float: left"
        width="110"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        key="20"
        prop="role"
        :label="$root.htmlConst.cons_116_table_header_sv"
        width="60"
        :filters="$root.chatDailySvFilters"
        :filter-method="filterSV"
        filter-placement="bottom-end"
        :resizable="false"
      ></el-table-column>
      <el-table-column
        key="68"
        prop="chatDailyCount"
        :label="$root.htmlConst.cons_131_table_header_count"
        :resizable="false"
      >
      </el-table-column>
      <el-table-column
        :label="$root.htmlConst.cons_132_table_header_daily_time"
        v-if="$root.dailyTimeFlg === '1'"
        :resizable="false"
      >
        <el-table-column
          key="48"
          :label="$root.htmlConst.cons_133_table_header_sum"
          prop="chatDailyTime"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          key="49"
          :label="$root.htmlConst.cons_134_table_header_ave"
          prop="chatDailyAverageTime"
          :resizable="false"
        >
        </el-table-column>
      </el-table-column>
      <el-table-column key="50" :label="$root.htmlConst.cons_152_table_header_word_rate" :resizable="false">
        <el-table-column key="51" :label="$root.htmlConst.cons_151_table_header_wowword">
          <el-table-column
            key="52"
            :label="$root.htmlConst.cons_124_table_header_questioner"
            prop="questionerWowwordRate"
          >
          </el-table-column>
          <el-table-column
            key="68"
            :label="$root.htmlConst.cons_125_table_header_operator"
            prop="opertorWowwordRate"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column key="53" :label="$root.htmlConst.cons_126_table_header_ngword">
          <el-table-column
            key="54"
            :label="$root.htmlConst.cons_124_table_header_questioner"
            prop="questionerNgwordRate"
          >
          </el-table-column>
          <el-table-column
            key="55"
            :label="$root.htmlConst.cons_125_table_header_operator"
            prop="opertorNgwordRate"
          >
          </el-table-column>
        </el-table-column>
        <el-table-column key="56" :label="$root.htmlConst.cons_150_table_header_ngmanner">
          <el-table-column
            key="57"
            :label="$root.htmlConst.cons_125_table_header_operator"
            prop="opertorNgmannarRate"
          >
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column
        :label="$root.htmlConst.cons_135_table_header_traffic"
        v-if="$root.dailySatisfactionIndex === 'display'"
        :resizable="false"
      >
        <el-table-column
          key="58"
          :label="$root.htmlConst.cons_124_table_header_questioner"
          prop="questionerDailyFrequency"
          :resizable="false"
        >
        </el-table-column>
        <el-table-column
          key="59"
          :label="$root.htmlConst.cons_125_table_header_operator"
          prop="operatorDailyFrequency"
          :resizable="false"
        >
        </el-table-column>
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
// import data1 from './chatList3.json'
import api from "@/api";
var moment = require("moment-timezone");
var sd = require("silly-datetime");
import { find } from "lodash";
export default {
  name: "ChatDetailTable",
  data() {
    return {
			sup_icon1: require('@/assets/sup_icon1.svg'),
      emptyText: "",
      lockReconnect: false,
      allTextData: [],
      allCustomerTextData: [],
      allAgentTextData: [],
      dialogTitle: "",
      dialogVisible: false,
      confirmDialogVisible: false,
      conUuid: "",
      input: "",
      search: "",
      oldSearch: "",
      loading: this.loading,
      realTimeloading: this.realTimeloading,
      dailyloading: this.dailyloading,
      dialogCustomId: "",
      dialogOperatorId: "",
      userTextInterval: "",
      timer: "",
      dialogTime: "",
      index: "",
      checkIndex: 0,
      searchIndex: 1,
      searchCustomerIndex: 1,
      searchAgentIndex: 1,
      multipleSelection: [],
      multipleCustomerSelection: [],
      multipleAgentSelection: [],
      personChatFlag: false,
      svSendFlg: false,
    };
  },
  created() {
    if (this.$root.user.user_id) {
      this.getChatRealTimeTableDetail();
      this.getChatDailyTableDetail();
    } else {
      api.getUserInfo().then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            this.$root.user = data.user;
            this.getChatRealTimeTableDetail();
            this.getChatDailyTableDetail();
          }
        },
        (err) => {
          console.log(err);
        }
      );
    }
  },
  mounted: function () {
    var _this = this;
    this.timer = setInterval(function () {
      for (let data of _this.$root.chatRealTimeTableData) {
        if (data.answerTime) {
          let timezone = 9;
          let offset_GMT = new Date().getTimezoneOffset();
          let nowDate = new Date().getTime();
          let time = sd.format(
            new Date(nowDate + offset_GMT * 60 * 1000 + timezone * 60 * 60 * 1000),
            "YYYY-MM-DD HH:mm:ss"
          );
          var answerTime = moment(
            new Date(data.answerTime.replace(/T/g, " ").replace(/\.[\d]{3}Z/, ""))
          ).format("YYYY-MM-DD HH:mm:ss");
          let outTime = "";
          let hours = moment(time).diff(moment(answerTime), "hours");
          if (hours > 0) {
            if (hours < 10) {
              outTime = outTime + "0" + hours + ":";
            } else {
              outTime = outTime + hours + ":";
            }
          } else {
            outTime = outTime + "00:";
          }
          let minutes = moment(time).diff(moment(answerTime), "minutes") % 60;
          if (minutes > 0) {
            if (minutes < 10) {
              outTime = outTime + "0" + minutes + ":";
            } else {
              outTime = outTime + minutes + ":";
            }
          } else {
            outTime = outTime + "00:";
          }
          let seconds = (moment(time).diff(moment(answerTime), "seconds") % 60) % 60;
          if (seconds > 0) {
            if (seconds < 10) {
              outTime = outTime + "0" + seconds;
            } else {
              outTime = outTime + seconds;
            }
          } else {
            outTime = outTime + "00";
          }
          data.time = outTime;
        }
      }
    }, 1000);
  },
  beforeDestroy: function () {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    filterGroup(value, row) {
      return row.groupName === value;
    },
    filterSV(value, row) {
      return row.role === value;
    },
    filterStatus(value, row) {
      return row.presence === value;
    },
    getChatRealTimeTableDetail: function () {
      this.realTimeloading = true;
      this.$root.isDataLoading = true
      api.getChatRealTimeTableDetail(this.$root.user.user_id).then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            // let data = data1
            this.$root.chatRealTimeTableData = data.output_list;
            for (let groupName of data.output_list.map((v) => v.groupName)) {
              let groupNameFilter = {};
              if (
                !this.$root.chatRealTimeGroupFilters
                  .map((v) => v.value)
                  .includes(groupName)
              ) {
                groupNameFilter.text = groupName;
                groupNameFilter.value = groupName;
                this.$root.chatRealTimeGroupFilters.push(groupNameFilter);
              }
            }
            for (let role of data.output_list.map((v) => v.role)) {
              let svFilter = {};
              if (!this.$root.chatRealTimeSvFilters.map((v) => v.value).includes(role)) {
                svFilter.text = role;
                svFilter.value = role;
                this.$root.chatRealTimeSvFilters.push(svFilter);
              }
            }
            for (let presence of data.output_list.map((v) => v.presence)) {
              let statusFilter = {};
              if (
                !this.$root.chatRealTimeStatusFilters
                  .map((v) => v.value)
                  .includes(presence)
              ) {
                statusFilter.text = presence;
                statusFilter.value = presence;
                this.$root.chatRealTimeStatusFilters.push(statusFilter);
              }
            }
            this.$root.chatNgCount = data.ngCount;
            this.$root.chatSVDependCount = data.svDependCount;
            this.realTimeloading = false;
            this.$root.isDataLoading = false;

          }
        },
        (err) => {
          console.log(err);
        }
      );
    },

    getChatDailyTableDetail: function () {
      this.dailyloading = true;
      api.getChatDailyTableDetail(this.$root.user.user_id).then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            // let data = data1
            this.$root.chatDailyTableData = data.output_list;
            for (let groupName of data.output_list.map((v) => v.groupName)) {
              let groupNameFilter = {};
              if (
                !this.$root.chatDailyGroupFilters.map((v) => v.value).includes(groupName)
              ) {
                groupNameFilter.text = groupName;
                groupNameFilter.value = groupName;
                this.$root.chatDailyGroupFilters.push(groupNameFilter);
              }
            }
            for (let role of data.output_list.map((v) => v.role)) {
              let svFilter = {};
              if (!this.$root.chatDailySvFilters.map((v) => v.value).includes(role)) {
                svFilter.text = role;
                svFilter.value = role;
                this.$root.chatDailySvFilters.push(svFilter);
              }
            }
            this.dailyloading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    createWebSocket(url) {
      var statusLockReconnect = false;
      var that = this;
      try {
        if ("WebSocket" in window) {
          that.statusWs = new WebSocket(url);
        }
        let heartCheck = {
          timeout: 1000,
          timeoutObj: null,
          serverTimeoutObj: null,
          reset: function () {
            clearTimeout(this.timeoutObj);
            clearTimeout(this.serverTimeoutObj);
            return this;
          },
          start: function () {
            let self = this;
            this.timeoutObj = setTimeout(function () {
              if (that.statusWs != null && that.statusWs.readyState == 1) {
                that.statusWs.send("ping");
              }
              self.serverTimeoutObj = setTimeout(function () {}, self.timeout);
            }, this.timeout);
          },
        };
        that.statusWs.onclose = function (event) {
          if (statusLockReconnect) return;
          statusLockReconnect = true;
          setTimeout(function () {
            if (that.personChatFlag) {
              that.createWebSocket(url);
              statusLockReconnect = false;
            }
          }, 2000);
          console.log("status websocket close event:", event);
        };
        that.statusWs.onerror = function (err) {
          if (statusLockReconnect) return;
          statusLockReconnect = true;
          setTimeout(function () {
            if (that.personChatFlag) {
              that.createWebSocket(url);
              statusLockReconnect = false;
            }
          }, 2000);
          console.log("status websocket err:", err);
        };
        that.statusWs.onopen = function () {
          heartCheck.reset().start();
          console.log("status websocket open.");
        };
        that.statusWs.onmessage = function (event) {
          heartCheck.reset().start();
          if (event.data != "pong") {
            console.log("chat message websocket data", event.data);
            if (JSON.parse(event.data).type == "message") {
              let item;
              let mqseq = JSON.parse(event.data).mqseq;
              if (that.$root.mqseqList.length > 0 && that.$root.mqseqList.indexOf(mqseq) > -1){
                return;
              } else {
                that.$root.mqseqList.push(mqseq);
              }
              let receiveJson = {
                  type: 'received',
                  mqseq: mqseq
              };
              that.statusWs.send(JSON.stringify(receiveJson));
              if (JSON.parse(event.data).role == "operator" || JSON.parse(event.data).role == "supervisor") {
                item = {
                  flag: "right",
                  user: JSON.parse(event.data).name,
                  text: JSON.parse(event.data).message,
                  time: moment(JSON.parse(event.data).time)
                    .utcOffset(-1)
                    .format("YYYY-MM-DD HH:mm"),
                  role: JSON.parse(event.data).role,
                  logo: JSON.parse(event.data).logo
                };
              } else {
                item = {
                  flag: "left",
                  user: JSON.parse(event.data).name,
                  text: JSON.parse(event.data).message,
                  time: moment(JSON.parse(event.data).time)
                    .utcOffset(-1)
                    .format("YYYY-MM-DD HH:mm"),
                  role: JSON.parse(event.data).role,
                  logo: JSON.parse(event.data).logo
                };
              }
              
              that.allCustomerTextData.push(item);
              that.allTextData.push(item);
            } else if (JSON.parse(event.data).type == "innerMessage") {
              let mqseq = JSON.parse(event.data).mqseq;
              if (that.$root.mqseqList.length > 0 && that.$root.mqseqList.indexOf(mqseq) > -1){
                return;
              } else {
                that.$root.mqseqList.push(mqseq);
              }
              let receiveJson = {
                  type: 'received',
                  mqseq: mqseq
              };
              that.statusWs.send(JSON.stringify(receiveJson));
              let item = {
                  flag: "left",
                  user: JSON.parse(event.data).name,
                  text: JSON.parse(event.data).message,
                  time: moment(JSON.parse(event.data).time)
                    .utcOffset(-1)
                    .format("YYYY-MM-DD HH:mm"),
                  role: "operatorInner",
                  logo: JSON.parse(event.data).logo
                };
              that.allAgentTextData.push(item);
              that.allTextData.push(item);
            } else if (JSON.parse(event.data).type == "close") {
              let mqseq = JSON.parse(event.data).mqseq;
              if (that.$root.mqseqList.length > 0 && that.$root.mqseqList.indexOf(mqseq) > -1){
                return;
              } else {
                that.$root.mqseqList.push(mqseq);
              }
              let receiveJson = {
                  type: 'received',
                  mqseq: mqseq
              };
              that.statusWs.send(JSON.stringify(receiveJson));
              that.personChatFlag = false;
              that.svSendFlg = false;
              that.statusWs.close();
            } else {
              console.log("else");
            }
          }
        };
      } catch (e) {
        if (statusLockReconnect) return;
        statusLockReconnect = true;
        setTimeout(function () {
          if (that.personChatFlag) {
            that.createWebSocket(url);
            statusLockReconnect = false;
          }
        }, 2000);
        console.log("status websocket create err:", e);
      }
    },

    viewAllText(index, row) {
      this.index = index;
      this.personChatFlag = true;
      this.dialogVisible = true;
      this.allTextData = [];
      this.allCustomerTextData = [];
      this.allAgentTextData = [];
      this.multipleSelection = [];
      this.loading = true;
      this.dialogCustomId = row.customId;
      this.dialogOperatorId = row.loginId;
      this.dialogTitle = row.operatorName;
      this.$root.mqseqList = []

      let websocketUrl =
        this.$root.websocketUrl +
        "/chat/message?userId=" +
        this.$root.user.user_id +
        "&type=UC3" +
        "&customerId=" +
        row.customId;
      console.log(websocketUrl);
      this.createWebSocket(websocketUrl);
      let _this = this;
      api.getUserChatText(this.$root.user.user_id ,row.issueId).then(
        (res) => {
          if (res && res.data) {
            _this.allCustomerTextData = res.data.output_customer_list;
            _this.allAgentTextData = res.data.output_agent_list;
            _this.allTextData = res.data.output_list;
            _this.svSendFlg = row.svhelperCanTextFlg;
            _this.searchAllText("load");
            if (!_this.search) {
              _this.$refs.multipleTableLeft.bodyWrapper.scrollTop =
                _this.$refs.multipleTableLeft.bodyWrapper.scrollHeight;
              _this.$refs.multipleTableRight.bodyWrapper.scrollTop =
                _this.$refs.multipleTableRight.bodyWrapper.scrollHeight;
            }
            _this.loading = false;
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    sendMessage(type) {
      let inputValue = document.getElementById("message").value;
      if (inputValue == null || inputValue == "" || inputValue == "\n") {
        document.getElementById("message").value = "";
        return;
      }
      //document.getElementById("message").value = "";
      let time = moment().format("YYYY-MM-DD HH:mm");
      let that = this;
      let item;
      if (type == 'textMonitor') {
        item = {
          flag: "right",
          user: "あなた",
          text: inputValue,
          time: time,
          role: this.$root.user.role,
          logo: this.$root.user.logo_url
        };
        that.allCustomerTextData.push(item);
      } else if (type == 'svInnerChat') {
        item = {
          flag: "right",
          user: "あなた",
          text: inputValue,
          time: time,
          role: 'supervisorInner',
          logo: this.$root.user.logo_url
        };
        that.allAgentTextData.push(item);
      }
      that.allTextData.push(item);
     // document.getElementById("message").value = ' ';
     // document.getElementById("message").value = ''
      this.input = " ";
      this.input = "";
      api
        .sendMessage(this.$root.user.user_id, this.dialogCustomId, inputValue, type)
        .then(() => {

        });
    },
    handleClose() {
      let self = this;
      self.allTextData = [];
      self.allCustomerTextData = [];
      self.allAgentTextData = [];
      self.message = "";
      self.search = "";
      self.oldSearch = "";
      self.multipleSelection = [];
      this.dialogVisible = false;
      clearInterval(this.userTextInterval);
      api.chatClose(this.$root.user.user_id, this.dialogCustomId).then((res) => {
        console.log(res.data);
        self.personChatFlag = false;
        self.svSendFlg = false;
        self.statusWs.close();
      });
    },
    searchAllText(action) {
      if (action == "search") {
        this.searchIndex = 1;
        this.searchCustomerIndex = 1;
        this.searchAgentIndex = 1;
        this.multipleSelection = [];
        this.multipleCustomerSelection = [];
        this.multipleAgentSelection = [];
      }
      if (this.oldSearch) {
        for (let text of this.allCustomerTextData) {
          if (text.text.includes(this.oldSearch)) {
            text.text = text.text.replace(
              RegExp('<span class="resultOn">' + this.oldSearch + "</span>", "g"),
              this.oldSearch
            );
            text.text = text.text.replace(
              RegExp('<span class="resultOff">' + this.oldSearch + "</span>", "g"),
              this.oldSearch
            );
          }
        }

         for (let text of this.allAgentTextData) {
          if (text.text.includes(this.oldSearch)) {
            text.text = text.text.replace(
              RegExp('<span class="resultOn">' + this.oldSearch + "</span>", "g"),
              this.oldSearch
            );
            text.text = text.text.replace(
              RegExp('<span class="resultOff">' + this.oldSearch + "</span>", "g"),
              this.oldSearch
            );
          }
        }
      }
      if (this.search) {
        let tmpmultipleCustomerSelection = [];
        let tmpmultipleAgentSelection = [];

        let allCustomerCount = 0;
        for (var k = 0; k < this.allCustomerTextData.length; k++) {
          let count = 0;
          if (this.allCustomerTextData[k].text.includes(this.search)) {
            this.allCustomerTextData[k].text = this.allCustomerTextData[k].text.replace(
              RegExp(this.search, "g"),
              '<span class="resultOn">' + this.search + "</span>"
            );
            count = this.allCustomerTextData[k].text.split(this.search).length - 1;
          }
          for (var l = 1; l <= count; l++) {
            let data = {
              rowIndex: k,
              rowSearchIndex: l,
              searchIndex: allCustomerCount + l
            };
            tmpmultipleCustomerSelection.push(data);
          }
          allCustomerCount = allCustomerCount + count;
        }
        this.multipleCustomerSelection = tmpmultipleCustomerSelection;

        let allAgentCount = 0;
        for (var r = 0; r < this.allAgentTextData.length; r++) {
          let count = 0;
          if (this.allAgentTextData[r].text.includes(this.search)) {
            this.allAgentTextData[r].text = this.allAgentTextData[r].text.replace(
              RegExp(this.search, "g"),
              '<span class="resultOn">' + this.search + "</span>"
            );
            count = this.allAgentTextData[r].text.split(this.search).length - 1;
          }
          for (var t = 1; t <= count; t++) {
            let data = {
              rowIndex: r,
              rowSearchIndex: t,
              searchIndex: allAgentCount + t
            };
            tmpmultipleAgentSelection.push(data);
          }
          allAgentCount = allAgentCount + count;
        }
        this.multipleAgentSelection = tmpmultipleAgentSelection;

        
        if (this.multipleCustomerSelection.length > 0) {
          const customerItem = find(this.multipleCustomerSelection, {
            searchIndex: this.searchCustomerIndex
          });

          let rowCustomerContentList = this.allCustomerTextData[customerItem.rowIndex].text.split(this.search);
          let newCustomerContent = "";
          for (var m = 0; m < rowCustomerContentList.length; m++) {
            if (m == customerItem.rowSearchIndex - 1) {
              newCustomerContent =
                newCustomerContent +
                rowCustomerContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
            } else {
              newCustomerContent = newCustomerContent + rowCustomerContentList[m];
            }
            if (m != rowCustomerContentList.length - 1) {
              newCustomerContent = newCustomerContent + this.search;
            }
          }
          this.allCustomerTextData[customerItem.rowIndex].text = newCustomerContent;
          this.setCustomerCurrentRow(customerItem.rowIndex);
        }
        if (this.multipleAgentSelection.length > 0) {
          const agentItem = find(this.multipleAgentSelection, {
            searchIndex: this.searchAgentIndex
          });
          let rowAgentContentList = this.allAgentTextData[agentItem.rowIndex].text.split(this.search);
          let newAgentContent = "";
          for (var n = 0; n < rowAgentContentList.length; n++) {
            if (n == agentItem.rowSearchIndex - 1) {
              newAgentContent =
                newAgentContent +
                rowAgentContentList[n].replace(RegExp("resultOn", "g"), "resultOff");
            } else {
              newAgentContent = newAgentContent + rowAgentContentList[n];
            }
            if (n != rowAgentContentList.length - 1) {
              newAgentContent = newAgentContent + this.search;
            }
          }
          this.allAgentTextData[agentItem.rowIndex].text = newAgentContent;
          this.setAgentCurrentRow(agentItem.rowIndex);
        }
      }
      if (this.multipleCustomerSelection.length >= this.multipleAgentSelection.length) {
        this.multipleSelection = this.multipleCustomerSelection;
      } else {
        this.multipleSelection = this.multipleAgentSelection;
      }
      this.oldSearch = this.search;
    },
    downSelect() {
      for (let text of this.allCustomerTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      for (let text of this.allAgentTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      if (this.searchCustomerIndex >= this.multipleCustomerSelection.length) {
        this.searchCustomerIndex = 1;
      } else {
        this.searchCustomerIndex += 1;
      }

      if (this.searchAgentIndex >= this.multipleAgentSelection.length) {
        this.searchAgentIndex = 1;
      } else {
        this.searchAgentIndex += 1;
      }

      if (this.searchIndex >= this.multipleSelection.length) {
        this.searchIndex = 1;
      } else {
        this.searchIndex += 1;
      }

      const customerItem = find(this.multipleCustomerSelection, {
        searchIndex: this.searchCustomerIndex
      });

      if (customerItem) {
        let rowCustomerContentList = this.allCustomerTextData[customerItem.rowIndex].text.split(this.search);
        let newCustomerContent = "";
        for (var m = 0; m < rowCustomerContentList.length; m++) {
          if (m == customerItem.rowSearchIndex - 1) {
            newCustomerContent =
              newCustomerContent +
              rowCustomerContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
          } else {
            newCustomerContent = newCustomerContent + rowCustomerContentList[m];
          }
          if (m != rowCustomerContentList.length - 1) {
            newCustomerContent = newCustomerContent + this.search;
          }
        }
        this.allCustomerTextData[customerItem.rowIndex].text = newCustomerContent;
        this.setCustomerCurrentRow(customerItem.rowIndex);
      }
      
      const agentItem = find(this.multipleAgentSelection, {
          searchIndex: this.searchAgentIndex
      });
      if (agentItem) {
        let rowAgentContentList = this.allAgentTextData[agentItem.rowIndex].text.split(this.search);
        let newAgentContent = "";
        for (var n = 0; n < rowAgentContentList.length; n++) {
          if (n == agentItem.rowSearchIndex - 1) {
            newAgentContent =
              newAgentContent +
              rowAgentContentList[n].replace(RegExp("resultOn", "g"), "resultOff");
          } else {
            newAgentContent = newAgentContent + rowAgentContentList[n];
          }
          if (n != rowAgentContentList.length - 1) {
            newAgentContent = newAgentContent + this.search;
          }
        }
        this.allAgentTextData[agentItem.rowIndex].text = newAgentContent;
        this.setAgentCurrentRow(agentItem.rowIndex);
      }
    },
    upSelect() {
      for (let text of this.allCustomerTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }
      for (let text of this.allAgentTextData) {
        text.text = text.text.replace(RegExp("resultOff", "g"), "resultOn");
      }

      if (this.searchCustomerIndex == 1) {
        this.searchCustomerIndex = this.multipleCustomerSelection.length;
      } else {
        this.searchCustomerIndex -= 1;
      }

      if (this.searchAgentIndex == 1) {
        this.searchAgentIndex = this.multipleAgentSelection.length;
      } else {
        this.searchAgentIndex -= 1;
      }

      if (this.searchIndex == 1) {
        this.searchIndex = this.multipleSelection.length;
      } else {
        this.searchIndex -= 1;
      }

      const customerItem = find(this.multipleCustomerSelection, {
        searchIndex: this.searchCustomerIndex
      });
      if (customerItem) {
        let rowCustomerContentList = this.allCustomerTextData[customerItem.rowIndex].text.split(this.search);
        let newCustomerContent = "";
        for (var m = 0; m < rowCustomerContentList.length; m++) {
          if (m == customerItem.rowSearchIndex - 1) {
            newCustomerContent =
              newCustomerContent +
              rowCustomerContentList[m].replace(RegExp("resultOn", "g"), "resultOff");
          } else {
            newCustomerContent = newCustomerContent + rowCustomerContentList[m];
          }
          if (m != rowCustomerContentList.length - 1) {
            newCustomerContent = newCustomerContent + this.search;
          }
        }
        this.allCustomerTextData[customerItem.rowIndex].text = newCustomerContent;
        this.setCustomerCurrentRow(customerItem.rowIndex);
      }

      const agentItem = find(this.multipleAgentSelection, {
        searchIndex: this.searchAgentIndex
      });
      if (agentItem) {
        let rowAgentContentList = this.allAgentTextData[agentItem.rowIndex].text.split(this.search);
        let newAgentContent = "";
        for (var n = 0; n < rowAgentContentList.length; n++) {
          if (n == agentItem.rowSearchIndex - 1) {
            newAgentContent =
              newAgentContent +
              rowAgentContentList[n].replace(RegExp("resultOn", "g"), "resultOff");
          } else {
            newAgentContent = newAgentContent + rowAgentContentList[n];
          }
          if (n != rowAgentContentList.length - 1) {
            newAgentContent = newAgentContent + this.search;
          }
        }
        this.allAgentTextData[agentItem.rowIndex].text = newAgentContent;
        this.setAgentCurrentRow(agentItem.rowIndex);
      }
      
    },
    setCustomerCurrentRow(customerIndex) {
      if (this.multipleCustomerSelection.length == 0) {
        return false;
      } else {
        const targetLeftTop = this.$refs.multipleTableLeft.$el
          .querySelectorAll(".el-table__body tr")[customerIndex].getBoundingClientRect().top;
        const containerLeftTop = this.$refs.multipleTableLeft.$el
          .querySelector(".el-table__body")
          .getBoundingClientRect().top;
        const scrollLeftParent = this.$refs.multipleTableLeft.$el.querySelector(
          ".el-table__body-wrapper"
        );
        let scrollLeftHeight = targetLeftTop - containerLeftTop;
        scrollLeftParent.scrollTop = scrollLeftHeight;
      }
    },
    setAgentCurrentRow(agentIndex) {
      if (this.multipleAgentSelection.length == 0) {
        return false;
      } else {
        const targetRightTop = this.$refs.multipleTableRight.$el
          .querySelectorAll(".el-table__body tr")[agentIndex].getBoundingClientRect().top;
        const containerRightTop = this.$refs.multipleTableRight.$el
          .querySelector(".el-table__body")
          .getBoundingClientRect().top;
        const scrollRightParent = this.$refs.multipleTableRight.$el.querySelector(
          ".el-table__body-wrapper"
        );
        let scrollRightHeight = targetRightTop - containerRightTop;
        scrollRightParent.scrollTop = scrollRightHeight;
      }
    },
    svHelpClick(row) {
      api.svhelpOnSupport("MANUAL_CHAT_MODE",row.operatorId,this.$root.user.user_id,row.customId).then(
        (res) => {
          if (res && res.data) {
            console.log("svhelpOnSupport success");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
    resetSvHelpClick(row) {
      api.resetSvhelpOnSupport("MANUAL_CHAT_MODE",row.operatorId,this.$root.user.user_id,row.customId).then(
        (res) => {
          if (res && res.data) {
            console.log("svhelpOnSupport reset success");
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>

<style lang="scss">
.chat-search-input {
  .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
  }
}
.chat_dailog .el-dialog__header {
  background-color: #94E3FF;
  color: #125478;
}
.chat-table thead.is-group th {
  background-color:#94E3FF !important;
  color: #125478 !important;
}
.footer-box {
  /* background-image: linear-gradient(to right, #5aaafa 0%, #41d6c3 100%); */
  background-color: #94E3FF;
  height: fit-content;
  padding: 8px 0px;
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}


.sup_btn {
	min-width: 105px;
	padding: 2px !important;
	display: flex;
	justify-content: center;
	align-items: center;
	img{
		display: inline-block;
		width: 13px;
		height: 13px;
		margin-bottom: -2px;
	}
	&.is-plain:focus, &.is-plain:hover{
		border-color: #DCDFE6 !important;
		color: #606266 !important;
	}
}
</style>
